var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import { getTheme, mergeStyles } from "@fluentui/react/lib/Styling";
var HeadingFontSize = /* @__PURE__ */ ((HeadingFontSize2) => {
  HeadingFontSize2["h1"] = "2em";
  HeadingFontSize2["h2"] = "1.75em";
  HeadingFontSize2["h3"] = "1.5em";
  HeadingFontSize2["h4"] = "1.25em";
  HeadingFontSize2["h5"] = "1em";
  HeadingFontSize2["h6"] = "0.75em";
  return HeadingFontSize2;
})(HeadingFontSize || {});
var HeadingMarginBotton = /* @__PURE__ */ ((HeadingMarginBotton2) => {
  HeadingMarginBotton2["content"] = "10px";
  HeadingMarginBotton2["layout"] = "0";
  return HeadingMarginBotton2;
})(HeadingMarginBotton || {});
const Heading = (props) => {
  const _a = props, { tag = "h1", type = "content", className } = _a, rest = __objRest(_a, ["tag", "type", "className"]);
  const theme = getTheme();
  const defaultStyles = mergeStyles(
    {
      marginTop: "0",
      marginBottom: HeadingMarginBotton[type],
      fontWeight: theme.fonts.xLarge.fontWeight,
      fontSize: HeadingFontSize[tag],
      color: theme.semanticColors.bodyText,
      fontFamily: theme.fonts.xLarge.fontFamily
    },
    className
  );
  const Tag = tag;
  return /* @__PURE__ */ jsx(Tag, __spreadProps(__spreadValues({ className: defaultStyles }, rest), { children: props.children }));
};
export {
  Heading,
  HeadingFontSize,
  HeadingMarginBotton
};
//# sourceMappingURL=Heading.js.map
